import { RefreshCw } from 'lucide-react';
import { Icon } from '@/shared/components/icons';
import { Banner, Button } from '@/shared/components/ui';
import { useT } from '@/shared/i18n/useT';
import { pwaMsgs } from './messages';
import { useUpdateServiceWorker } from './useUpdateServiceWorker';

export interface UpdateBannerProps {
  className?: string;
}

/** Aviso de versión nueva: al aceptar, el service worker en espera toma el control y la página se recarga. */
export function UpdateBanner({ className }: UpdateBannerProps) {
  const { t } = useT(pwaMsgs);
  const { updateAvailable, applyUpdate } = useUpdateServiceWorker();
  if (!updateAvailable) return null;
  return (
    <Banner
      tone="info"
      icon={<Icon icon={RefreshCw} />}
      title={t('update.title')}
      className={className}
      action={
        <Button size="sm" onClick={applyUpdate}>
          {t('update.action')}
        </Button>
      }
    >
      {t('update.body')}
    </Banner>
  );
}
